import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from '../api';
import { useContext } from "react";
import Footer from "../components/Footer";
import { AuthContext } from "../context/AuthContext";



const ModifierProfil = () => {

  const { user, loading, logout } = useContext(AuthContext);
    const navigate = useNavigate();
// Fonction pour nettoyer les langues corrompues
const extractValidLangues = (rawLangues) => {
  if (!Array.isArray(rawLangues)) return [];
  
  const validLangues = [];
  const allowed = ['Français', 'Anglais'];

  for (let item of rawLangues) {
    // Tente de parser jusqu'à obtenir une chaîne simple
    while (typeof item === 'string' && (item.startsWith('[') || item.startsWith('"'))) {
      try {
        const parsed = JSON.parse(item);
        if (typeof parsed === 'string') {
          item = parsed;
        } else if (Array.isArray(parsed) && parsed.length > 0) {
          item = parsed[0]; // prends le premier si c'est un tableau
        } else {
          break;
        }
      } catch (e) {
        break;
      }
    }

    // Vérifie que c'est une langue valide
    if (typeof item === 'string') {
      const clean = item.trim();
      if (allowed.includes(clean)) {
        validLangues.push(clean);
      }
    }
  }

  // Supprime les doublons
  return [...new Set(validLangues)];
};
  const [form, setForm] = useState({
    name: "",
    prenom: "",
    email: "",
    emailDeContact: "",
    password: "",
    photo: null,
    metier: "",
    domaine: [], 
    categories: [],
    autresDomaines: [],
    telephone: "",
    langues: [],
    nationalites: "",
    video: "",
    description: "",
    valeurs: "",
    lieuPrestation: "",
   // pmr: false,
    typeCours: "",
    liens: "",
    siteWeb:"",
    instagram:"",
    linkedin:""

  });
  

const categoriesDisponibles = [
  { nom: "Animaux & monde vivant", couleur: "#B36A5E" },
  { nom: "Architecture & urbanisme", couleur: "#E3CD8B" },
  { nom: "Arts vivants", couleur: "#F27438" },
  { nom: "Arts visuels", couleur: "#F39C12" },
  { nom: "Artisanat", couleur: "#CA7C5C" },
  { nom: "Bien-être", couleur: "#27AE60" },
  { nom: "Décoration & aménagement", couleur: "#e76f51" },
  { nom: "Développement personnel", couleur: "#9B59B6" },
  { nom: "Écologie & durabilité", couleur: "#7AA95C" },
  { nom: "Écriture & littérature", couleur: "#C89F9C" },
  { nom: "Entrepreneuriat & innovation", couleur: "#427AA1" },
  { nom: "Finances personnelles & économie", couleur: "#E8EDDF" },
  { nom: "Formation, enseignement & accompagnement", couleur: "#C8574D" },
  { nom: "Gastronomie & art culinaire", couleur: "#FFAE9D" },
  { nom: "Humanitaire & droits humains", couleur: "#7C4C53" },
  { nom: "Inclusion & solidarité", couleur: "#FF584D" },
  { nom: "Informatique & numérique", couleur: "#3498DB" },
  { nom: "Jeux & expériences interactives", couleur: "#0FAC71" },
  { nom: "Management & organisation", couleur: "#9281C0" },
  { nom: "Marketing, Communication & Événementiel", couleur: "#4A919E" },
  { nom: "Médias, journalisme & storytelling", couleur: "#A92831" },
  { nom: "Musique & son", couleur: "#FFBF66" },
  { nom: "Nature, jardinage & permaculture", couleur: "#B7CE66" },
  { nom: "Parentalité & famille", couleur: "#EA5863" },
  { nom: "Politique, citoyenneté & engagement sociétal", couleur: "#585B4C" },
  { nom: "Relations & développement social", couleur: "#E74C3C" },
  { nom: "Santé", couleur: "#EDCDFA" },
  { nom: "Sciences & technologies", couleur: "#62B9CB" },
  { nom: "Sport, loisirs physiques & outdoor", couleur: "#5CAFE7" },
  { nom: "Spiritualité", couleur: "#FFE361" },
  { nom: "Stylisme & mode", couleur: "#F0A1BF" },
  { nom: "Thérapies alternatives", couleur: "#A4BD01" },
  { nom: "Voyage, tourisme & interculturalité", couleur: "#7DC2A5" },
{ nom: "Autres", couleur: "#95a5a6" }
];
  const languesDisponibles = ['Français', 'Anglais'];

useEffect(() => {
  if (loading) return;

  if (!user || (!user.id && !user._id)) {
    navigate("/login", { replace: true });
    return;
  }

  const userId = user.id || user._id;

  api.get(`/api/users/${userId}`)
    .then((res) => {
      const userData = res.data;
      setForm({
        name: userData.name || "",
        prenom: userData.prenom || "",
        email: userData.email || "",
        emailDeContact: userData.emailDeContact || userData.mailDeContact || userData.contactEmail || "",
        password: "",
        photo: null,
        metier: userData.metier || "",
        domaine: Array.isArray(userData.domaine)
  ? userData.domaine
  : userData.domaine
  ? [userData.domaine]
  : [],

langues: extractValidLangues(userData.langues),
          telephone: userData.telephone || "",
        description: userData.description || "",
        valeurs: userData.valeurs || "",
        nationalites: userData.nationalites || "",
        video: userData.video || "",
        lieuPrestation: userData.lieuPrestation || "",
        typeCours: userData.typeCours || "",
        siteWeb: userData.siteWeb || "",
        instagram: userData.instagram || "",
        linkedin: userData.linkedin || "",
        autresDomaines: [],

categories: Array.isArray(userData.categories)
  ? userData.categories.map(cat =>
      typeof cat === "string" ? cat : cat.nom
    )
  : [],
      });
    })
    .catch((err) => {
      console.error("Erreur chargement profil :", err);
      navigate("/dashboard", { replace: true });
    });
}, [user, loading, navigate]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };
  const handleDomaineChange = (value) => {
  setForm((prev) => {
    if (prev.domaine.includes(value)) {
      return {
        ...prev,
        domaine: prev.domaine.filter((d) => d !== value),
      };
    }

    const effectiveCount = [
      ...(prev.domaine.filter((d) => d !== "Autres")),
      ...((prev.autresDomaines || []).map((v) => v.trim()).filter(Boolean)),
    ].length;

    if (effectiveCount >= 10) {
      return prev;
    }

    if (value === "Autres") {
      return {
        ...prev,
        domaine: [...prev.domaine, value],
        autresDomaines: prev.autresDomaines?.length ? prev.autresDomaines : [""],
      };
    }

    return {
      ...prev,
      domaine: [...prev.domaine, value],
    };
  });
};

  const addAutreDomaine = () => {
    setForm((prev) => {
      const effectiveCount = [
        ...(prev.domaine.filter((d) => d !== "Autres")),
        ...((prev.autresDomaines || []).map((v) => v.trim()).filter(Boolean)),
      ].length;

      if (effectiveCount >= 10) {
        return prev;
      }

      return {
        ...prev,
        autresDomaines: [...(prev.autresDomaines || []), ""],
      };
    });
  };

  const updateAutreDomaine = (index, value) => {
    setForm((prev) => ({
      ...prev,
      autresDomaines: (prev.autresDomaines || []).map((item, idx) => idx === index ? value : item),
    }));
  };

  const removeAutreDomaine = (index) => {
    setForm((prev) => ({
      ...prev,
      autresDomaines: (prev.autresDomaines || []).filter((_, idx) => idx !== index),
    }));
  };


  const handleLangueChange = (langue) => {
    setForm((prev) => ({
      ...prev,
      langues: prev.langues.includes(langue)
        ? prev.langues.filter((l) => l !== langue)
        : [...prev.langues, langue],
    }));
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files?.[0] || null;
    setForm({ ...form, photo: file });
  };

  const profilePhotoPreview = form.photo
    ? (typeof form.photo === "string" ? form.photo : URL.createObjectURL(form.photo))
    : "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
   const userId = JSON.parse(localStorage.getItem("user"))?.id 
            || JSON.parse(localStorage.getItem("user"))?._id;


    if (!token || !userId) {
      alert("Non authentifié");
      return navigate("/login");
    }

    const finalDomaine = [
      ...form.domaine.filter((d) => d !== "Autres"),
      ...((form.autresDomaines || []).map((v) => v.trim()).filter(Boolean)),
    ].slice(0, 10);

    const passwordToUpdate = String(form.password || "").trim();
    const data = new FormData();
    Object.keys(form).forEach((key) => {
      if (key === "photo" && !form.photo) return;
      if (key === "autresDomaines") return;
      if (key === "email") return;
      if (key === "password" && !passwordToUpdate) return;
      if (key === "domaine") {
        finalDomaine.forEach((item) => data.append(key, item));
        return;
      }
      if (key === "emailDeContact") {
        const contactEmail = String(form.emailDeContact || "").trim();
        if (contactEmail) {
          data.append("emailDeContact", contactEmail);
        }
        return;
      }
      if (key === "mailDeContact") {
        const legacyContactEmail = String(form.mailDeContact || "").trim();
        if (legacyContactEmail) {
          data.append("emailDeContact", legacyContactEmail);
        }
        return;
      }
      if (Array.isArray(form[key])) {
        form[key].forEach((item) => data.append(key, item));
      } else {
        data.append(key, form[key] ?? "");
      }
    });

    if (passwordToUpdate) {
      data.append("password", passwordToUpdate);
    }

    try {
      const res = await api.put(`/api/auth/complete-profile/${userId}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const storedUser = JSON.parse(localStorage.getItem("user"));

      localStorage.setItem(
        "user",
        JSON.stringify({
          ...storedUser,
          ...res.data,
        })
      );

      localStorage.setItem("profileCompleted", "true");

      if (passwordToUpdate) {
        logout();
        alert("Mot de passe mis à jour. Veuillez vous reconnecter.");
        return navigate("/login", { replace: true });
      }

      alert("Profil mis à jour !");
      navigate("/profile");
    } catch (error) {
      alert(error.response?.data?.msg || "Erreur");
    }
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDeleteAccount = async () => {
    const token = localStorage.getItem("token");
    const userId = user?.id || user?._id;
    try {
      await api.delete(`/api/auth/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      logout();
      navigate("/login", { replace: true });
    } catch (error) {
      alert(error.response?.data?.msg || "Erreur lors de la suppression du compte");
    }
  };

  if (loading) {
  return (
    <div className="min-h-screen flex items-center justify-center">
      Chargement...
    </div>
  );
}



  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--app-background)' }}>
      {/* Header */}
      <header className="bg-white border-b px-6 py-4 flex items-center justify-between">
       { /*<img src={logo} alt="Logo" className="h-8" /> */} 
        <button
          onClick={() => navigate("/profile")}
          className="link-fuchsia"
        >
          ← Retour au profil
        </button>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-8">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <h1 className="text-2xl font-bold text-gray-800 mb-6">Modifier le profil</h1>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Photo */}
            <div className="rounded-2xl border border-dashed border-[var(--accent-primary)] bg-[var(--accent-primary-soft)] p-5">
              <div className="flex flex-col sm:flex-row items-center gap-4">
                <div className="w-20 h-20 rounded-full bg-white border-2 border-[var(--accent-primary)] overflow-hidden flex items-center justify-center text-[var(--accent-primary)] shadow-sm">
                  {profilePhotoPreview ? (
                    <img src={profilePhotoPreview} alt="Aperçu" className="w-full h-full object-cover" />
                  ) : (
                    <span className="text-2xl">📷</span>
                  )}
                </div>

                <div className="flex-1 text-center sm:text-left">
                  <p className="font-semibold text-gray-800">Photo de profil</p>
                  <p className="text-xs text-gray-600 mt-1">JPG, PNG ou WebP • jusqu’à 5 Mo</p>
                  <label className="inline-flex mt-3 items-center justify-center bg-[var(--accent-primary)] text-white rounded-full px-4 py-2 text-sm font-medium cursor-pointer hover:opacity-95 transition">
                    Changer la photo
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handlePhotoChange}
                      className="hidden"
                    />
                  </label>
                  {form.photo && typeof form.photo !== "string" && (
                    <p className="text-xs text-gray-500 mt-2">Fichier sélectionné : {form.photo.name}</p>
                  )}
                </div>
              </div>
            </div>

            {/* Informations de base */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                placeholder="Nom"
                value={form.name}
                onChange={handleChange}
                required
                className="border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)]"
              />
              <input
                type="text"
                name="prenom"
                placeholder="Prénom"
                value={form.prenom}
                onChange={handleChange}
                required
                className="border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)]"
              />
              <div className="md:col-span-2">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={form.email}
                  disabled
                  readOnly
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 bg-gray-100 text-gray-500 cursor-not-allowed focus:outline-none"
                />
                <p className="text-xs text-gray-500 mt-1">L’email ne peut pas être modifié ici.</p>
              </div>
              <input
                type="password"
                name="password"
                placeholder="Nouveau mot de passe (optionnel)"
                value={form.password}
                onChange={handleChange}
                className="border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)]"
              />
            </div>

            {/* Champs Créateur */}
             {user?.role === "createur" && (

              <div className="bg-gray-50 p-6 rounded-xl space-y-5">
                <h2 className="text-xl font-semibold text-gray-800">Informations Créateur</h2>

                <input
                  type="text"
                  name="metier"
                  placeholder="Métier (optionnel)"
                  value={form.metier}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                />

                <div>
  <p className="text-gray-700 font-medium">
    Domaines d’activité :
  </p>

  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2">
    {categoriesDisponibles.map((cat) => (
      <label
        key={cat.nom}
        className="flex items-center gap-2 text-gray-700"
      >
        <input
          type="checkbox"
          checked={form.domaine.includes(cat.nom)}
          onChange={() => handleDomaineChange(cat.nom)}
        />
        {cat.nom}
      </label>
    ))}
  </div>

  {/* Champ Autres */}
  {form.domaine.includes("Autres") && (
    <div className="mt-3 space-y-2">
      <div className="flex items-center justify-between">
        <label className="block text-gray-700 text-sm font-medium">
          Catégories libres supplémentaires
        </label>
        <button
          type="button"
          onClick={addAutreDomaine}
          className="text-xs text-[var(--accent-primary)] hover:underline"
        >
          + Ajouter
        </button>
      </div>

      {(form.autresDomaines || []).map((value, index) => (
        <div key={index} className="flex items-center gap-2">
          <input
            type="text"
            value={value}
            onChange={(e) => updateAutreDomaine(index, e.target.value)}
            placeholder="Ex : Coaching, Photographie..."
            className="w-full border border-gray-300 px-3 py-2 rounded-lg"
          />
          <button
            type="button"
            onClick={() => removeAutreDomaine(index)}
            className="text-gray-500 hover:text-red-600 text-sm"
          >
            Retirer
          </button>
        </div>
      ))}

      {(!form.autresDomaines || form.autresDomaines.length === 0) && (
        <button
          type="button"
          onClick={addAutreDomaine}
          className="text-sm text-[var(--accent-primary)] hover:underline"
        >
          Ajouter une catégorie "Autres"
        </button>
      )}
    </div>
  )}

  {/* Erreur si vide */}
  {form.domaine.length === 0 && (
    <p className="text-red-500 text-sm mt-1">
      Veuillez sélectionner au moins une catégorie
    </p>
  )}
</div>


                <div>
                  <p className="text-gray-700 font-medium">Langues parlées :</p>
                  <div className="flex flex-wrap gap-4 mt-2">
                    {languesDisponibles.map(langue => (
                      <label key={langue} className="flex items-center gap-1">
                        <input
                          type="checkbox"
                          checked={form.langues.includes(langue)}
                          onChange={() => handleLangueChange(langue)}
                        /> {langue}
                      </label>
                    ))}
                  </div>
                </div>

                <input
                  type="text"
                  name="nationalites"
                  placeholder="Nationalités"
                  value={form.nationalites}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                />

                <input
                  type="tel"
                  name="telephone"
                  placeholder="Téléphone (optionnel)"
                  value={form.telephone}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                />

                <input
                  type="email"
                  name="emailDeContact"
                  placeholder="Email de contact du créateur"
                  value={form.emailDeContact}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                />

                <input
                  type="url"
                  name="video"
                  placeholder=" Lien vidéo de présentation"
                  value={form.video}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                />

                <textarea
                  name="description"
                  placeholder="À propos de moi"
                  value={form.description}
                  onChange={handleChange}
                  rows="3"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                />

                <textarea
                  name="valeurs"
                  placeholder="Mes valeurs profondes "
                  value={form.valeurs}
                  onChange={handleChange}
                  rows="2"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                />

                <select
                  name="lieuPrestation"
                  value={form.lieuPrestation}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                >
                  <option value="">Lieu de prestation</option>
                  <option value="En ligne">Distanciel</option>
                  <option value="Présentiel">Présentiel</option>
                  <option value="Distanciel & Présentiel">Distanciel & Présentiel</option>
                </select>

             {/*   <label className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    name="pmr"
                    checked={form.pmr}
                    onChange={handleChange}
                  />
                                    Accessible PMR (Personnes à mobilité réduite) 

                </label>   */}  

                 <select
                  name="typeCours"
                  value={form.typeCours}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                >
                  <option value="">Type de séance</option>
                 
                <option value="Individuelle">Individuelle</option>
<option value="Collective">Collective</option>
<option value="Individuelle & Collective">
  Individuelle & Collective
</option>
                </select>

                                <div className="space-y-3">
  <p className="text-gray-700 font-medium">Liens</p>

  <input
    type="url"
    name="siteWeb"
    placeholder="Site Web"
    value={form.siteWeb || ""}
    onChange={handleChange}
    className="w-full border border-gray-300 rounded-lg px-4 py-3"
  />

  <input
    type="url"
    name="instagram"
    placeholder="Instagram"
    value={form.instagram || ""}
    onChange={handleChange}
    className="w-full border border-gray-300 rounded-lg px-4 py-3"
  />

  <input
    type="url"
    name="linkedin"
    placeholder="LinkedIn"
    value={form.linkedin || ""}
    onChange={handleChange}
    className="w-full border border-gray-300 rounded-lg px-4 py-3"
  />
</div>
              </div>
            )}

            {/* Boutons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button
  type="submit"
  className="btn-primary py-3 px-6 font-semibold"
>
  Enregistrer les modifications
</button>

              <button
                type="button"
                onClick={() => setShowDeleteModal(true)}
                className="py-3 px-6 font-medium rounded-lg border border-red-500 text-red-500 hover:bg-red-50 transition-colors"
              >
                Supprimer le compte
              </button>
            </div>
          </form>
        </div>
      </main>

      {/* Modal confirmation suppression */}
      {showDeleteModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-sm w-full mx-4">
            <h2 className="text-xl font-bold text-gray-800 mb-2">Supprimer le compte</h2>
            <p className="text-gray-600 mb-6">
              Cette action est <strong>définitive</strong>. Toutes vos données seront supprimées et vous ne pourrez pas récupérer votre compte.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={handleDeleteAccount}
                className="flex-1 py-3 px-4 bg-red-500 hover:bg-red-600 text-white font-semibold rounded-lg transition-colors"
              >
                Oui, supprimer définitivement
              </button>
              <button
                onClick={() => setShowDeleteModal(false)}
                className="flex-1 py-3 px-4 btn-outline-accent font-medium"
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default ModifierProfil;